/* eslint-disable camelcase */
/* eslint-disable no-eval */
let dgram = null;
let events = null;
const vendor = "Mediworks";
let server;
try {
  if (window !== undefined && window !== null) {
    dgram = require("dgram");
    events = require("events");
  }
} catch (error) {
  dgram = eval("require")("dgram");
  events = eval("require")("events");
}

export default class Client extends events {
  constructor(option = {}) {
    super();
    this.multicastTTL = option["multicastTTL"] || 128;
    this.broadcast = true;
    this.emitKey = {
      listening: "listening",
      message: "message"
    };
  }
  send_msg(msg, port = 37099, multicast_ip = "224.0.0.100") {
    if (server) {
      msg = { vendor: vendor, data: msg, timeStamp: new Date().getTime() };
      // console.log('send msg:', msg)
      server.send(JSON.stringify(msg), port, multicast_ip);
    }
  }
  startDeviceDiscoverClient() {
    if (!server) {
      server = dgram.createSocket("udp4");
      server.on("close", () => {});

      server.on("error", (err) => {
        console.log("client error" + err);
      });
      server.on("listening", () => {
        server.setBroadcast(this.broadcast);
        server.setMulticastTTL(this.multicastTTL);
        this.emit(this.emitKey.listening, server);
      });

      server.on("message", (msg, rinfo) => {
        msg = msg.toString();
        msg = JSON.parse(msg);
        if (msg["vendor"] !== undefined && msg["vendor"] != null && msg["vendor"] === vendor) {
          this.emit(this.emitKey.message, msg.data, rinfo);
        }
      });
      server.bind(); // 随机绑定本机一个端口
      return server;
    }
  }
  clear() {
    if (server !== null && server !== undefined) {
      server.close();
      server = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mainInterface/js/DiscoveryProtocolUdp.js